import { render, staticRenderFns } from "./dragHandleBigIcon.vue?vue&type=template&id=7136640f&"
import script from "./dragHandleBigIcon.vue?vue&type=script&lang=js&"
export * from "./dragHandleBigIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports